import { useOrganizationDetails } from 'features/organizations/hooks/useOrganizationDetails';
import {
  UseOrganizationUpgrade,
  useOrganizationUpgrade,
} from 'features/organizations/hooks/useOrganizationUpgrade';

type UseOrganizationUpgradePreviewProps = {
  regularSeats: number;
  proSeats: number;
};

export const useOrganizationUpgradePreview = ({
  regularSeats,
  proSeats,
}: UseOrganizationUpgradePreviewProps): UseOrganizationUpgrade => {
  const { details } = useOrganizationDetails();

  const previewOrganizationUpgrade =
    (regularSeats || proSeats) > 0
      ? {
          regularSeats: (details?.seats.regular.purchased || 0) + regularSeats,
          proSeats: (details?.seats.pro.purchased || 0) + proSeats,
        }
      : undefined;

  return useOrganizationUpgrade({ previewOrganizationUpgrade });
};
